import React, { useState } from 'react';
import './Sauvegarde.css';
import AnimatedSection from '../../Hook/Block';
import useCountUp from '../../Hook/useCountUp';
import Chiffrement from './Chiffrement.png';
import Chiffrement1 from './Chiffrement1.png';
import Stockage from './Stockage.png';
import Blockchain from './Blockchaine.png';
import Securise from "./Securise.png";
import PricingConfigurator from '../../Hook/PricingSimulator';
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema';
import SEO from '../../Hook/Seo';
import TarifsSection from '../../Hook/TarifSection';
import VideoPresentationInformatique from '../../pages/Informatique/video_presentation_informatique.mp4';

const Sauvegarde = () => {
  const clients1 = useCountUp(500, 2000);
  const [openTarifs, setOpenTarifs] = useState({ fixe: false, mobile: false });

  return (
    <>
      <SEO
        title="Solutions de Sauvegarde Informatique & Cloud dans les Vosges | AM Services"
        description="Sauvegardes automatisées, externalisées et chiffrées de bout en bout pour entreprises vosgiennes."
        path="/sauvegarde"
        keywords={["sauvegarde informatique", "sauvegarde cloud", "sécurité informatique", "RGPD", "Vosges"]}
      />
      <BreadcrumbsSchema />

      {/* 1. ACCUEIL PLEIN ÉCRAN CINÉMATIQUE (100VH) */}
      <div className="save-hero-container">
        <div className="save-video-wrapper">
          <video
            src={VideoPresentationInformatique}
            autoPlay
            muted
            loop
            playsInline
            className="save-background-video"
            aria-label="Vidéo de présentation solutions de sauvegarde"
          />
          <div className="save-hero-overlay"></div>
        </div>

        <div className="save-hero-center-text">
          <h1 className="save-title">SAUVEGARDE & PROTECTION</h1>
          <p className="save-lead">
            Chez AM Services, nous sécurisons et protégeons vos données critiques en toute simplicité.
          </p>
        </div>

        <div className="scroll-indicator" onClick={() => document.getElementById('save-content-start').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* 2. ZONE DE CONTENU BLANCHE ET PROPRE */}
      <div className="save-showcase-section" id="save-content-start">
        
        {/* BLOC 1 : SAUVEGARDE CLOUD EXTERNALISÉE */}
        <div className="save-animated-wrapper">
          <AnimatedSection
            sectionTitle="Sauvegarde Cloud Professionnelle"
            direction="left"
            items={[
              { img: Chiffrement, alt: "Chiffrement avancé", title: "Chiffrement de bout en bout", text: "Vos fichiers sont chiffrés avant de quitter votre ordinateur, rendant leur lecture impossible sans votre clé privée unique." },
              { img: Stockage, alt: "Stockage décentralisé", title: "Stockage souverain Europe", text: "Les données sont découpées et réparties sur de nombreux centres sécurisés en Europe, assurant fiabilité, redondance et disponibilité permanente." },
              { img: Securise, alt: "Accès sécurisé", title: "Contrôle exclusif de l'accès", text: "Votre entreprise détient seule la clé de lecture, empêchant toute modification, suppression ou consultation non autorisée des fichiers." },
              { img: Blockchain, alt: "Technologie blockchain", title: "Traçabilité par blockchain", text: "Chaque sauvegarde est inscrite dans une chaîne inviolable. Cela garantit la transparence, l’authenticité et l’impossibilité de falsifier vos données." }
            ]}
            count={clients1}
            countLabel="Clients satisfaits"
          />
        </div>

        {/* 3. SECTION GRILLE DE TARIFS HARMONISÉE */}
        <div className="save-pricing-wrapper">
          <TarifsSection
            name="Sauvegarde"
            buttonLabel="Nos tarifs Sauvegardes"
            sectionTitle="Nos Plans de Stockage"
            tarifs={[
              { title: "Pour 100 Go", description: "Parfait pour les petites structures : sauvegarde de documents essentiels et données administratives.", price: "14,90 € HT" },
              { title: "Pour 500 Go", description: "Idéal pour les TPE/PME : combine sauvegarde bureautique et sécurisation de bases de données légères.", price: "29,90 € HT" },
              { title: "Pour 1 To", description: "Conçu pour les équipes grandissantes : centralisation des projets, archives et fichiers multimédias lourds.", price: "49,90 € HT" },
              { title: "Pour 2 To", description: "Adapté aux entreprises : gestion de volumes importants avec redondance et disponibilité garantie.", price: "79,90 € HT" },
              { title: "Pour 4 To", description: "Solution complète : sauvegardes systèmes, environnements critiques et conformité RGPD sans compromis.", price: "129,90 € HT" }
            ]}
            openTarifs={openTarifs}
            setOpenTarifs={setOpenTarifs}
          />
        </div>

        {/* BLOC 2 : ESPACE DRIVE SÉCURISÉ */}
        <div className="save-animated-wrapper second-block-spacing">
          <AnimatedSection
            sectionTitle="Espace de Stockage Drive Sécurisé"
            direction="left"
            items={[
              { img: Chiffrement1, alt: "Chiffrement Drive", title: "Chiffrement complet", text: "Vos fichiers Drive sont sécurisés avant envoi, accessibles uniquement par vous grâce à une clé privée unique." },
              { img: Stockage, alt: "Stockage européen", title: "Stockage fiable en Europe", text: "Vos données Drive sont réparties sur plusieurs centres sécurisés pour une fiabilité et une disponibilité maximales." },
              { img: Securise, alt: "Accès Drive sécurisé", title: "Contrôle total", text: "Vous gardez le contrôle exclusif de vos fichiers : lecture, modification et suppression sont réservées à votre entreprise." },
              { img: Blockchain, alt: "Traçabilité Drive", title: "Intégrité garantie", text: "Votre espace Drive est traçable et inviolable, assurant transparence et protection contre toute falsification." }
            ]}
            countLabel="Clients satisfaits"
          />
        </div>

        {/* CONFIGURATEUR ET SIMULATEUR DE PRIX DE FIN DE PAGE */}
        <div className="save-configurator-wrapper">
          <PricingConfigurator />
        </div>

      </div>
    </>
  );
};

export default Sauvegarde;